import { ConfigStore } from '~/stores/config.store';
import { FullstoryService } from '~/services/fullstory/fullstory.service';
import { INetworkStore } from '~/types/dependency.types';
import { ToastStore } from '~/stores/toast.store';
import { NetworkStore } from '~/stores/network.store';
import { IApiService } from '~/services/interfaces/IApiService';
import invariant from 'ts-invariant';
import { IAnalyticsService } from '~/services/interfaces/IAnalyticsService';
import { StorageService } from '~/services/storage-service';
import { GracefulService } from '~/services/graceful.service';

export interface BaseGlobalContextValue {
    get configStore(): ConfigStore;
    get gracefulService(): GracefulService;

    // Util services
    get analyticsService(): IAnalyticsService;

    get fullstoryService(): FullstoryService;

    get storageService(): StorageService;

    // Api services
    get networkStore(): INetworkStore;

    get apiService(): IApiService; // Can be authorized when logged in and not authorized when logged out

    // UI services
    get toastStore(): ToastStore;
}

export abstract class BaseGlobalContext implements BaseGlobalContextValue {
    // Config
    configStore: ConfigStore;
    gracefulService: GracefulService;

    // Util services
    abstract analyticsService: IAnalyticsService;
    fullstoryService: FullstoryService;
    storageService: StorageService;

    // Api services
    networkStore: INetworkStore;
    apiService: IApiService;

    // UI services
    toastStore: ToastStore;

    constructor() {
        this.configStore = new ConfigStore();
        this.gracefulService = new GracefulService({
            configStore: this.configStore
        });

        this.fullstoryService = new FullstoryService({
            envGetter: this.configStore
        });

        this.networkStore = new NetworkStore({
            logger: this.fullstoryService
        });
        this.storageService = new StorageService();
        this.apiService = this.initApiServices();
        invariant(this.apiService, 'apiService must be initialized');

        this.toastStore = new ToastStore();
    }

    abstract initApiServices(): IApiService;
}
